// extracted by mini-css-extract-plugin
export default {"openBets":"styles_openBets__IH1bw"};